export const SectionHeadingFontFamily = Styles.fontFamily.base;
